<template>
  <div class="border border-gray-600 flex flex-col mt-auto p-4 rounded-lg">
    <div class="flex">
      <div class="bg-gray-200 flex h-12 items-center justify-center rounded-full shrink-0 w-12">
        <cx-icon :name="userRoleIcon" class="text-gray-600" size="2xl" />
      </div>

      <div class="flex flex-col justify-center ml-2 truncate w-full">
        <div class="flex justify-between w-full">
          <p v-hubble="'user-name'" class="font-semibold mr-4 text-white truncate">{{ $auth.user.name }}</p>
          <cx-badge
            v-hubble="'user-role-badge'"
            color="gray"
            class="flex h-[22px] items-center justify-center ml-auto"
            >{{ userRoleName }}</cx-badge
          >
        </div>

        <p v-hubble="'user-email'" class="text-gray-300 text-xs truncate">{{ $auth.user.email }}</p>
      </div>
    </div>

    <div class="flex items-center mt-4">
      <!-- TODO: replace this with cx-button when there's a fitting theme -->
      <button
        v-hubble="'manage-profile-button'"
        class="border border-white flex font-medium grow items-center justify-center mr-2 py-2 rounded-lg text-white text-xs"
        @click="$router.push({ name: 'settings-general' })"
      >
        {{ $t('manageSettings') }}
      </button>

      <cx-tooltip :content="$t('logout')">
        <nuxt-link
          v-hubble="'logout-button'"
          class="flex h-10 items-center justify-center w-10"
          :to="{ name: 'logout' }"
        >
          <cx-icon name="logout-box-r-line" class="text-gray-400" size="2xl" />
        </nuxt-link>
      </cx-tooltip>
    </div>
  </div>
</template>

<script>
import { CxBadge, CxIcon, CxTooltip } from '~/components/cx';
import {
  USER_ROLE_MAP,
  CLIENT,
  CLIENT_ADMIN,
  CRUX_ADMIN,
  CRUX_OPERATOR,
  CRUX_STEWARD,
  DATA_ENGINEER,
} from '~/support/constants';

export const ROLE_ICON_MAP = {
  [CLIENT_ADMIN]: 'user-settings-line',
  [CRUX_OPERATOR]: 'computer-line',
  [CRUX_STEWARD]: 'safe-line',
  [CRUX_ADMIN]: 'shield-user-line',
  [DATA_ENGINEER]: 'code-line',
  [CLIENT]: 'eye-line',
};

export default {
  name: 'AppSidebarRoleCard',

  hubble: 'app-sidebar-role-card',

  components: { CxBadge, CxIcon, CxTooltip },

  computed: {
    userRole() {
      return this.$auth.user.roles[0];
    },

    userRoleIcon() {
      return ROLE_ICON_MAP[this.userRole];
    },

    userRoleName() {
      return USER_ROLE_MAP[this.userRole];
    },
  },
};
</script>

<i18n lang="json">
{
  "en": {
    "manageSettings": "Manage Settings",
    "logout": "Logout"
  }
}
</i18n>
